import React, { useMemo, useState, useEffect } from 'react';
import { T } from "react-translator-component";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faBed } from '@fortawesome/free-solid-svg-icons';
import { apartmentsRooms, isDemo } from './CheckIn/hotelConditions';
import { isHostz } from './CheckIn/hotelConditions';
import { useKiosk } from '../hooks/useKiosk';


export default function CheckInIdentifySelector({ hotel, onSubmit, error, setError, loading }) {
  const [method, setMethod] = useState(null);
  const [formData, setFormData] = useState({ code: '', lastName: '', room: '' });
  const { isKioskMode } = useKiosk();
  const handleInputChange = (e) => {
    setError(false);
    let sanitizedData = String(e.target.value).toUpperCase();
    if (e.target.name == 'code') {
      sanitizedData = sanitizedData.replace(/\s/g, "")
    }

    setFormData(prev => ({ ...prev, [e.target.name]: sanitizedData }));
  };

  const handleSubmit = () => {
    if (onSubmit) onSubmit(formData);
  };

  const handleBack = () => {
    setError(false);
    if (method == 'inhouse') {
      setMethod('code');
    } else {
      setMethod('inhouse');
    }
    setFormData({ code: '', lastName: '', room: '' });
  };

  const { disableBtnSend } = useMemo(() => {
    let res = { disableBtnSend: true }

    switch (method) {
      case 'code':
        res.disableBtnSend = (formData?.code.trim() == '' || formData?.code.trim().length < 4);
        break;

      case 'inhouse':
        res.disableBtnSend = ((formData?.lastName.trim() == '') || (formData?.room.trim() == ''));
        break;
      case 'kiosk':
        res.disableBtnSend = ((formData?.lastName.trim() == '') || (formData?.code.trim() == ''));
        break;
      default:
      //disabled
    }

    return res;
  }, [method, formData])

  useEffect(() => {
    if(isKioskMode) {
      setMethod('kiosk');
    }
  }, [isKioskMode])

  const roomNumber = useMemo(() => {
    let res = T("room.number");
    if (apartmentsRooms(hotel?.id)) {
      res = T("apartment.number");
    }
    return res;
  }, [hotel]);

  return (
    <>
      <div>

        {!isHostz(hotel?.id) ? (
          <>
            <h4 className='mb-4 font-weight-bold identify-screen-title'>{T("general.identify-screen.title")}</h4>
            <p className='identify-screen-subtitle'>
              {!method ? T("general.identify-screen.subtitle") : isKioskMode ? T("general.identify-screen.subtitle-2") : T("general.identify-screen.subtitle-1")}
            </p>
          </>
        ) : (
          <>
            <h4 className='mb-4 font-weight-bold identify-screen-title'>{T("general.identify-screen.title-hostz")}</h4>
          </>
        )}
      
        {!method && (
          <div
            className="mt-4 d-flex justify-content-center flex-wrap"
            style={{ width: '100%', maxWidth: 480, margin: '0 auto', gap: 20 }}
          >
            <button
              className="d-flex flex-column align-items-center justify-content-center btn btn-light border"
              style={{ flex: '1 1 140px', minWidth: 0, width: '100%', aspectRatio: '1/1', borderRadius: 16, fontSize: 16, border: '1.5px solid #e0e0e0', padding: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.30)', background: '#fff', maxWidth: '220px' }}
              onClick={() => setMethod('code')}
            >
              <FontAwesomeIcon icon={faLock} style={{ fontSize: 50, marginBottom: 32, color: '#888' }} />
              <span style={{ fontWeight: 400, fontSize: 16, color: '#333', textAlign: 'center', lineHeight: 1.1 }}>
                {T("general.identify-screen.button-code")}
              </span>
            </button>
            <button
              className="d-flex flex-column align-items-center justify-content-center btn btn-light border"
              style={{ flex: '1 1 140px', minWidth: 0, width: '100%', aspectRatio: '1/1', borderRadius: 16, fontSize: 16, border: '1.5px solid #e0e0e0', padding: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.30)', background: '#fff', maxWidth: '220px' }}
              onClick={() => setMethod('inhouse')}
            >
              <FontAwesomeIcon icon={faBed} style={{ fontSize: 50, marginBottom: 32, color: '#888' }} />
              <span style={{ fontWeight: 400, fontSize: 16, color: '#333', textAlign: 'center', lineHeight: 1.1 }}>
                {T("general.identify-screen.button-data")}
              </span>
            </button>
          </div>
        )}

        {method === 'code' && (
          <>
            <input
              type="text"
              placeholder={`${T("checkin.reservation-code")}...`}
              name="code"
              value={formData.code}
              maxLength={45}
              style={{ width: '100%', fontSize: 16, padding: '10px 12px', borderRadius: 8, border: '1.5px solid #ddd', background: '#f6f7f9', marginBottom: 12, color: '#222', outline: 'none', transition: 'border 0.2s, box-shadow 0.2s', textAlign: 'center' }}
              onFocus={e => { e.target.style.border = '1.5px solid #6ca0f6'; e.target.style.boxShadow = '0 0 0 2px #e0eaff'; }}
              onBlur={e => { e.target.style.border = '1.5px solid #ddd'; e.target.style.boxShadow = 'none'; }}
              onChange={handleInputChange}
            />
          </>
        )}

        {method === 'inhouse' && (
          <>
            <input
              type="text"
              placeholder={`${T("checkin.inputs.surname")}...`}
              name="lastName"
              value={formData.lastName}
              onChange={handleInputChange}
              style={{ width: '100%', fontSize: 16, padding: '10px 12px', borderRadius: 8, border: '1.5px solid #ddd', background: '#f6f7f9', marginBottom: 12, color: '#222', outline: 'none', transition: 'border 0.2s, box-shadow 0.2s', textAlign: 'center' }}
              onFocus={e => { e.target.style.border = '1.5px solid #6ca0f6'; e.target.style.boxShadow = '0 0 0 2px #e0eaff'; }}
              onBlur={e => { e.target.style.border = '1.5px solid #ddd'; e.target.style.boxShadow = 'none'; }}
            />
            <input
              type="text"
              placeholder={`${roomNumber}...`}
              name="room"
              value={formData.room}
              onChange={handleInputChange}
              style={{ width: '100%', fontSize: 16, padding: '10px 12px', borderRadius: 8, border: '1.5px solid #ddd', background: '#f6f7f9', marginBottom: 12, color: '#222', outline: 'none', transition: 'border 0.2s, box-shadow 0.2s', textAlign: 'center' }}
              onFocus={e => { e.target.style.border = '1.5px solid #6ca0f6'; e.target.style.boxShadow = '0 0 0 2px #e0eaff'; }}
              onBlur={e => { e.target.style.border = '1.5px solid #ddd'; e.target.style.boxShadow = 'none'; }}
            />
          </>
        )}

        {method === 'kiosk' && (
          <>
            <input
              type="text"
              placeholder={`${T("checkin.inputs.surname")}...`}
              name="lastName"
              value={formData.lastName}
              onChange={handleInputChange}
              style={{ width: '100%', fontSize: 16, padding: '10px 12px', borderRadius: 8, border: '1.5px solid #ddd', background: '#f6f7f9', marginBottom: 12, color: '#222', outline: 'none', transition: 'border 0.2s, box-shadow 0.2s', textAlign: 'center' }}
              autoComplete="off"
            />
            <input
              type="text"
              placeholder={`${T("checkin.reservation-code")}...`}
              name="code"
              value={formData.code}
              onChange={handleInputChange}
              style={{ width: '100%', fontSize: 16, padding: '10px 12px', borderRadius: 8, border: '1.5px solid #ddd', background: '#f6f7f9', marginBottom: 12, color: '#222', outline: 'none', transition: 'border 0.2s, box-shadow 0.2s', textAlign: 'center' }}
              autoComplete="off"
            />
          </>
        )}

        {error && method == 'code' && (
          <p className="text-danger mt-1">{T('general.identify-screen.error-code')}</p>
        )}
        {error && method == 'inhouse' && (
          <p className="text-danger mt-1">{T('general.identify-screen.error-data')}</p>
        )}
        {error && method == 'kiosk' && (
          <p className="text-danger mt-1">{T('general.identify-screen.error-data')}</p>
        )}

        {method && (
          <button
            className={`btn-identify btn-primary ${disableBtnSend || loading ? 'disabled' : 'enabled'}`}
            onClick={handleSubmit}
            disabled={disableBtnSend || loading}>{T("general.identify-screen.button-identify")}
            {loading && (
              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginLeft: 12, verticalAlign: 'middle' }}></span>
            )}
          </button>
        )}

        {method && method != 'kiosk' && (
          <button className='btn btn-sm btn-link text-muted mt-2' onClick={handleBack}>
            {method == 'inhouse' ? T("general.identify-screen.button-return-code") : T("general.identify-screen.button-return-data")}
          </button>
        )}

      </div >
    </>
  );
}